import catActions from '../actions/CatActions';

export const defaultState = {
    currentCatRevisionId: '',
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case catActions.types.CAT_SET_CURRENT_REVISION_ID:
        return Object.assign({}, state, {
            currentCatRevisionId: action.currentCatRevisionId,
        });
    case catActions.types.CAT_RESET_CURRENT_REVISION_ID:
        return Object.assign({}, defaultState);

    default:
        return state;
    }
}
